import { Drawer } from 'antd-v5';
import styled, { css } from 'styled-components';

const formatDrawerWidth = (width: number | string) => (typeof width === 'number' ? `${width}px` : width);

// `$contained` = bound to a parent element (getContainer): render absolutely inside it instead of
// the fixed, viewport-anchored page drawer used by default.
export const SAntDrawer = styled(Drawer)<{ offsetTop: number; $contained?: boolean; $width: number | string }>`
  ${({ $contained, offsetTop, $width }) =>
    $contained
      ? css`
          position: absolute;

          .ant5-drawer-body {
            overflow-x: hidden;
          }
        `
      : css`
          position: fixed;
          width: ${formatDrawerWidth($width)} !important;
          top: ${offsetTop}px;
          height: calc(100vh - ${offsetTop}px) !important;
          max-height: calc(100vh - ${offsetTop}px) !important;
          box-shadow: -2px 0 4px rgba(0, 0, 0, 0.2) !important;
        `}

  .ant5-drawer-header-title {
    flex-direction: row-reverse;
  }

  .ant5-drawer-footer {
    padding: 16px 24px;
  }
`;
